import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  colorAccessibleGreen,
  colorTelusPurple
} from '@tds/core-colours/dist/index.cjs';
import { Box, Text } from './../../design/css';

const DefectComments = ({ data, isAdmin }) => {
  return (
    <>
      {data.map((comment, index) => {
        const {
          text,
          is_admin_only,
          updatedAt,
          commenter_name: userName,
          commenter_role_id: roleId
        } = comment;

        const commentDate = moment(updatedAt).format(
          'dddd, MMMM Do YYYY, h:mm:ss a'
        );
        const key = `comment${index}`;
        let isAddedByAdmin = roleId === 1;
        const adminLabel = <span>{is_admin_only ? "[Admins only]" :""}</span>;
        const getAdmin = () => {
          return <span>{userName}{"  "}<span><span style={{ color: "#2B8000" }}>{adminLabel}{"  "}</span> -  </span></span>
        }
        return (
          <>
            {
              !isAdmin && is_admin_only ? null
                : text && (
                  <Box key={key} pt="20">
                    <Text bold color={colorTelusPurple}>
                      {isAddedByAdmin ? (isAdmin ? getAdmin() : 'Support - ') : `${userName} - `}
                    </Text>
                    <Text fontWeight="500">{`${text} - `}</Text>
                    <Text bold color={colorAccessibleGreen}>
                      {commentDate}
                    </Text>
                  </Box>
                )
            }
          </>
        );

      })}
    </>
  );
};

DefectComments.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      createdAt: PropTypes.string,
      user: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string
      })
    })
  ).isRequired
};

export default DefectComments;
